/* eslint-disable max-statements */
/* eslint-disable complexity */
/*eslint-disable no-console */

import { takeEvery, select, call, all, take } from 'redux-saga/effects';
import { isEmpty, identity, isUndefined } from '@mindtickle/utils';

import { mixpanelIdentity, mixpanelIdentityPath } from '../config';
import { DISABLE_TRACKING } from '../config/constants';
import mixpanelManager from '../helpers/mixpanelManager';

let trackingEvents = {};

/********* to be removed **********/
export const mixpanelClient = {
  track: (event, data) => {
    console.log('MIX_PANEL EVENT: ', event, ', DATA: ', data);
  },
};
/********* to be removed **********/

function getDataFromStore(path = '', store) {
  if (typeof path == 'string' && path.startsWith('@@store')) {
    path = path.split('.').splice(1);
    return path.reduce(
      (result, key, index) => (index !== path.length - 1 ? result[key] || {} : result[key]),
      store
    );
  }
  return path;
}

export function getBaseProperties(mixpanelPaths, mixpanelIdentity, store) {
  const baseProperties = {};
  Object.keys(mixpanelPaths).forEach(property => {
    let path = mixpanelPaths[property];
    let value;
    path = Array.isArray(path) ? path : [path];
    for (let i = 0; i < path.length; i++) {
      value = getDataFromStore(path[i], store);
      if (value) {
        break;
      }
    }
    let { name: names, processor = identity } = mixpanelIdentity[property] || {};
    names = Array.isArray(names) ? names : [names];
    names.forEach(name => {
      baseProperties[name] = processor(value);
    });
  });
  return baseProperties;
}

function getPropertyData(eventData, params, store) {
  const propertyData = {};
  Object.keys(eventData).forEach(key => {
    const { value: path, processor = identity } = eventData[key];
    const value = getDataFromStore(path, store);
    propertyData[key] = processor(value, params);
  });
  return propertyData;
}

function* getMixpanelIdentity({ context = {}, mixpanel = {} }) {
  let mixpanelPath = { ...mixpanel, ...mixpanelIdentityPath };
  let additionalPath = {};
  const store = yield select();
  if (!isEmpty(context)) {
    const type = context.type || context.moduleType;
    additionalPath = (store[type.toLowerCase()] && store[type.toLowerCase()].mixpanel) || {};
  }
  return getBaseProperties({ ...mixpanelPath, ...additionalPath }, mixpanelIdentity.get(), store);
}

function* fireEvent({ type: actionType, payload: { data: payloadData = {}, ...rest } = {} }) {
  try {
    const store = yield select();
    const TrackEventConfig = trackingEvents[actionType] || {};
    const mixpanelMeta = {
      op: payloadData.operation || rest.operation,
      opType: payloadData.type || rest.type,
      response: payloadData.response || rest.response || {},
      postData: payloadData.postData || rest.postData || {},
      context: payloadData.context || rest.context || {},
      mixpanel: payloadData.mixpanel || rest.mixpanel || {},
    };

    if (mixpanelMeta.postData.disableEvent) return;

    let trackingData = { ...TrackEventConfig };

    trackingData = mixpanelMeta.op ? trackingData[mixpanelMeta.op] : trackingData;
    trackingData =
      trackingData && mixpanelMeta.opType && mixpanelMeta.op
        ? trackingData[mixpanelMeta.opType]
        : trackingData;

    if (isEmpty(trackingData) || isUndefined(trackingData)) return;

    const baseProperties = yield call(getMixpanelIdentity, {
      context: mixpanelMeta.context,
      mixpanel: mixpanelMeta.mixpanel,
    });
    const params =
      isEmpty(mixpanelMeta.postData) || isUndefined(mixpanelMeta.postData)
        ? mixpanelMeta.response
        : mixpanelMeta.postData;

    const { data: eventData, event } = trackingData;
    if (isUndefined(eventData) || isUndefined(event)) return;

    const mixpanelData = {
      ...baseProperties,
      ...getPropertyData(eventData, params, store),
    };
    if (process.env.IS_DEV || process.env.isDev) {
      mixpanelClient.track(event, mixpanelData);
    } else if (process.env.TRACKING) {
      mixpanelManager.track(event, mixpanelData);
    }
  } catch (error) {
    if (process.env.IS_DEV || process.env.isDev) {
      throw error;
    }
  }
}

export function* trackEvents(events = {}) {
  trackingEvents = { ...trackingEvents, ...events };
  yield takeEvery(Object.keys(events), fireEvent);
}

function* stopTracking() {
  yield take(DISABLE_TRACKING);
  if (window.mixpanel && window.mixpanel.register) {
    yield window.mixpanel.register({ $ignore: true });
  }
}

export default function* () {
  yield all([stopTracking()]);
}
